import React, { useState } from 'react';
import { Modal } from '../../components/ui';
import { useToast } from '../../components/ui';
import { errMsg } from '../../utils/format';
import api from '../../utils/api';

export default function AddVendorModal({ onClose, onSaved }) {
  const { showToast, Toast } = useToast();
  const [form, setForm] = useState({ name:'', contactName:'', email:'', phone:'', address:'', notes:'' });
  const [saving, setSaving] = useState(false);

  const save = async (e) => {
    e.preventDefault(); setSaving(true);
    try {
      await api.post('/api/vendors', form);
      onSaved('Vendor added successfully'); onClose();
    } catch(err) { alert(errMsg(err)); }
    finally { setSaving(false); }
  };

  const set = (k,v) => setForm(f => ({...f, [k]:v}));

  return (
    <Modal title="Add Vendor" onClose={onClose}
      footer={<><button className="btn" onClick={onClose}>Cancel</button><button className="btn btn-primary" form="add-vendor-form" type="submit">{saving?'Saving…':'Add vendor'}</button></>}>
      <form id="add-vendor-form" onSubmit={save}>
        <div className="form-group"><label>Vendor name *</label><input required value={form.name} onChange={e=>set('name',e.target.value)} /></div>
        <div className="form-row">
          <div className="form-group"><label>Contact name</label><input value={form.contactName} onChange={e=>set('contactName',e.target.value)} /></div>
          <div className="form-group"><label>Email</label><input type="email" value={form.email} onChange={e=>set('email',e.target.value)} /></div>
        </div>
        <div className="form-group"><label>Phone</label><input value={form.phone} onChange={e=>set('phone',e.target.value)} /></div>
        <div className="form-group"><label>Address</label><textarea value={form.address} onChange={e=>set('address',e.target.value)} /></div>
        <div className="form-group"><label>Notes</label><textarea value={form.notes} onChange={e=>set('notes',e.target.value)} /></div>
      </form>
    </Modal>
  );
}
